<mat-card class="nsc-card"  [ngClass]="values.className"><ng-content></ng-content></mat-card>